import { Lightbulb, Scale, CheckCircle2, ArrowRight, Sparkles } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import TraceCard from "@/components/v2/TraceCard";

// Section "Pourquoi Energy Market ?" en grille bento :
// grande tuile mission + 3 tuiles d'étapes animées (liseré au survol) + tuile stat.
const STEPS = [
  { title: "Comprendre", text: "Analyser votre situation et vos besoins énergétiques.", icon: Lightbulb, c: "#2E7D62" },
  { title: "Comparer", text: "Étudier les solutions réellement adaptées sur le marché.", icon: Scale, c: "#7AB317" },
  { title: "Choisir", text: "Vous accompagner sereinement dans votre prise de décision.", icon: CheckCircle2, c: "#0E9C8A" },
];

export default function WhyBento() {
  return (
    <section className="bg-secondary">
      <div className="em-container em-section">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4 md:auto-rows-fr">
          {/* Tuile mission */}
          <div className="md:col-span-2 md:row-span-2 flex flex-col rounded-3xl bg-primary text-primary-foreground p-8 md:p-10">
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-accent">Pourquoi Energy Market ?</p>
            <h2 className="mt-3 font-display text-3xl md:text-4xl font-black leading-tight">Comprendre, comparer, choisir</h2>
            <p className="mt-5 leading-relaxed text-primary-foreground/80">
              Entre les fournisseurs, les évolutions tarifaires et la diversité des contrats, il est difficile d'identifier
              les solutions vraiment adaptées. Notre mission : un accompagnement clair, accessible et personnalisé — pour
              les particuliers comme pour les professionnels.
            </p>
            <div className="mt-auto pt-8">
              <Button asChild className="rounded-full bg-accent text-accent-foreground hover:bg-accent/90 font-bold">
                <Link to="/contact?type=etude">
                  Demander une étude gratuite <ArrowRight className="ml-1 h-4 w-4" />
                </Link>
              </Button>
            </div>
          </div>

          {/* 3 étapes */}
          {STEPS.map((s, i) => {
            const Icon = s.icon;
            return (
              <TraceCard
                key={s.title}
                index={i}
                radius={24}
                accent={s.c}
                className="flex flex-col rounded-3xl border border-border bg-card p-6"
              >
                <div className="relative flex h-11 w-11 items-center justify-center rounded-xl text-white" style={{ background: s.c }}>
                  <Icon className="h-5 w-5" strokeWidth={2.2} />
                </div>
                <h3 className="relative mt-4 font-display text-lg font-bold text-primary">{s.title}</h3>
                <p className="relative mt-1.5 text-sm leading-relaxed text-muted-foreground">{s.text}</p>
              </TraceCard>
            );
          })}

          {/* Tuile stat */}
          <div className="flex flex-col justify-center rounded-3xl bg-accent p-6 text-accent-foreground">
            <p className="font-display text-4xl font-black leading-none">9 ans</p>
            <p className="mt-2 text-sm font-semibold">d'expertise sur le marché de l'énergie</p>
            <Sparkles className="mt-3 h-5 w-5 opacity-70" aria-hidden />
          </div>
        </div>
      </div>
    </section>
  );
}
